// @flow
import React from 'react';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';

import Tooltip from 'app/common/ui/Tooltip';

import { statuses } from '../PurchasesApi';
import styles from './StatusTip.module.scss';;


const cx = classNames.bind(styles);

const styleByStatus = {
  [statuses.SPENT]: 'spent',
  [statuses.PENDING]: 'pending',
  [statuses.DELETED]: 'deleted',
};

const titleByStatus = {
  [statuses.SPENT]: 'orders_filter_item_spent',
  [statuses.PENDING]: 'orders_filter_item_pending',
  [statuses.DELETED]: 'orders_filter_item_deleted',
};

type Props = {
  status: $Values<typeof statuses>,
  createdBy?: string,
  conductedBy?: string,
}

const ToolTipContent = ({ status, createdBy, conductedBy }: Props) => {
  const { t } = useTranslation('cafeteria');

  return (
    <div className={styles.toolTipRoot}>
      <div className={styles.toolTipRow}>
        <span className={cx(styles.circle, { [styleByStatus[status]]: true })} />
        <span>{t(titleByStatus[status])}</span>
      </div>
      {createdBy
        && <div className={styles.toolTipGroup}>
          <div className={styles.propTitle}>
            {`${t('orders_status_tip_createdby_label', 'Создан')}:`}
          </div>
          <div>{createdBy}</div>
        </div>}
      {conductedBy
        && <div className={styles.toolTipGroup}>
          <div className={styles.propTitle}>
            {`${t('orders_status_tip_conductedby_label', 'Проведен')}:`}
          </div>
          <div>{conductedBy}</div>
        </div>}
    </div>
  );
};

const StatusTip = ({ status, createdBy, conductedBy }: Props) => (
  <Tooltip
    content={<ToolTipContent
      status={status}
      createdBy={createdBy}
      conductedBy={conductedBy}
    />}
  >
    <span className={cx(styles.circle, { [styleByStatus[status]]: true })} />
  </Tooltip>
);

export default StatusTip;
